<template>
    <Card>
        <p class="card-title" slot="title"><span>{{ title }}</span></p>
        <Poptip placement="bottom-end" v-if="more" slot="extra">
            <Icon type="md-more" color="#ccc"/>
            <div class="pop-content" slot="content">
                <div>
                    <label><Icon type="md-close" /> CLOSE</label>
                </div>
                <div @click.stop="hide = !hide">
                    <label><Icon :type="hide ? 'ios-arrow-down' : 'ios-arrow-up'" /> {{ hide ? 'SHOW' : 'HIDE' }}</label>
                </div>
            </div>
        </Poptip>
        <slot v-if="!hide"/>
    </Card>
</template>
<script>
export default {
    props: {
        more: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: 'title'
        }
    },
    data () {
        return {
            hide: false
        }
    }
}
</script>
<style>
.card-title {
    text-align: left;
}
.card-title span {
    color: #2b7cba;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    font-weight: 500;
}
.ivu-poptip-popper {
    min-width: 100px;
    z-index: 1510;
}
.ivu-card-body {
    transition: .8s ease-in;
}
.pop-content label {
    font-size: 10px;
    line-height: 2;
    font-weight: 400;
    font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
    cursor: pointer;
}
.pop-content div {
    border-bottom: 1px solid #ccc;
}
.pop-content div:last-child {
    border-bottom: none;
}
.pop-content label:hover {
    font-weight: 500;
}
</style>


// WEBPACK FOOTER //
// src/components/profile/nCard.vue